export const PAGE_TITLE = "Podcast";

export const PAGE_TEXT =
  "Listen to previous podcast episodes of Matthew Brownstein's Illuminated Mind Podcast or inquire about being a guest on the show.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1e3V3PQ5Feh96S3OvOrLbWftymYfe6Zv5/preview";

export const LINK_BOX_TITLE =
  "Illuminated Mind Podcast with Matthew J. Brownstein";

export const LINK_BOX_URL = "https://www.instituteofhypnotherapy.com/podcast/";

export const SECTION_TITLE = "Want to be a guest?";

export const GUEST_EMAIL = "mailto:support@mynirva.com";

export const GUEST_EMAIL_LABEL = "Email us at: support@mynirva.com";
